import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from '../reducers/sealing-element-maintenance.reducer';
import { sealingElementMaintenanceFeatureKey } from '../reducers/sealing-element-maintenance.reducer';

// feature
const featureState = createFeatureSelector<fromReducer.State>(sealingElementMaintenanceFeatureKey);

export const selectMaintenanceFilter = createSelector(featureState, state => state.filter);
export const selectMaintenanceSealingElementsResponse = createSelector(featureState, state => state.maintenance);
export const selectMaintenanceSealingElements = createSelector(selectMaintenanceSealingElementsResponse, resp => resp?.value ?? []);

export const selectMaintenanceSealingElementsCount = createSelector(selectMaintenanceSealingElementsResponse, resp => resp?.count ?? 0);

export const selectMaintenanceSkip = createSelector(selectMaintenanceSealingElementsResponse, resp => resp?.skip ?? 0);
export const selectMaintenanceTake = createSelector(selectMaintenanceSealingElementsResponse, resp => resp?.take ?? 50)
export const selectMaintenanceSealingElementsCurrentPage = createSelector(featureState, selectMaintenanceSkip, selectMaintenanceTake, (q, skip, take) => {
  if (skip === 0) return 1;
  const page = Math.ceil((skip ?? 0) / (take ?? 50)) + 1;
  return page
  // Math.ceil((skip ?? 0) / (take ?? 50)) + 1)
});

export const selectMaintenancePageDescription = createSelector(
  selectMaintenanceSkip,
  selectMaintenanceTake,
  selectMaintenanceSealingElementsCount,
  (skip, take, count) => `Showing ${skip === 0 ? 1 : take} through ${(skip === 0 ? 1 : skip) * take} of ${count}`);

export const selectMaintenanceSelection = createSelector(featureState, state => state.selection);

export const selectFilterQueryString = createSelector(selectMaintenanceFilter, selectMaintenanceSkip, selectMaintenanceTake,
  (filter, skip, take) => {

    let q = '?';
    if (!!filter.sbuID) q += `SBUID=${filter.sbuID}&`;
    if (!!filter.subSbuID) q += `subSBUID=${filter.subSbuID}&`;
    if (!!filter.productFamilyID) q += `productFamilyID=${filter.productFamilyID}&`;
    if (!!filter.equipmentTypeID) q += `equipmentTypeID=${filter.equipmentTypeID}&`;
    if (!!filter.pipeSizeID) q += `pipeSizeID=${filter.pipeSizeID}&`;
    if (!!filter.materialID) q += `materialID=${filter.materialID}&`;
    if (!!filter.innerDiameter) q += `innerDiameter=${filter.innerDiameter}&`;
    if (!!filter.partNumber) q += `partNumber=${filter.partNumber.replace('%', '')}&`;
    if (!!filter.partNumberMatcher) q += `PartNumberMatcherSymbol=${filter.partNumberMatcher}&`;

    if (!!filter.itemName) q += `itemName=${filter.itemName}&`;
    if (!!filter.createdBy) q += `createdBy=${filter.createdBy}&`;
    if (!!filter.updatedBy) q += `updatedBy=${filter.updatedBy}&`;

    // if (!!filter.pluggingHeadPartNumber) q += `pluggingHeadPartNumber=${filter.pluggingHeadPartNumber}&`;

    if ((filter.sellableWHID || []).length > 0) {
      const str = filter.sellableWHID!.map(c => `SellableCodesWH=${c}`).join('&');
      q += str + '&';
    };

    if ((filter.sellableEHID || []).length > 0) {
      const str = filter.sellableEHID!.map(c => `SellableCodesEH=${c}`).join('&');
      q += str + '&';
    };

    if ((filter.pipeSizeIDs || []).length > 0) {
      const str = filter.pipeSizeIDs?.map(p => `pipeSizeIDs=${p}`).join('&');
      q += str + '&';
    }

    if ((filter.equipmentTypeIDs || []).length > 0) {
      const str = filter.equipmentTypeIDs?.map(e => `equipmentTypeIDs=${e}`).join('&');
      q += str + '&';
    }

    if ((filter.materialIDs || []).length > 0) {
      const str = filter.materialIDs?.map(m => `materialIDs=${m}`).join('&');
      q += str + '&';
    }

    q += `skip=${skip}&`;
    q += `take=${take}&`;

    return q.substring(0, q.length - 1);
  });


export const selectHasMaintenanceLoader = (loader: fromReducer.Loaders) => createSelector(featureState, state => state.loaders.includes(loader));
